import Chart from 'chart.js'
import { Scatter, generateChart } from 'vue-chartjs'
import reactiveChartMixin from '../mixins/reactiveChart'
import VoronoiChart from './VoronoiChart.js'

const chartOptionsConfiguration = {
  animation: false,

  legend: {
    display: false
  },

  tooltips: {
    backgroundColor: "#6f6f6f",
    callbacks: {
      title: function (items, data) {
        const datasetIndex = items[0].datasetIndex
        const index = items[0].index
        return data.datasets[datasetIndex].data[index].label
      },
      label: function () {
        return ''
      }
    }
  },

  scales: {
    yAxes: [{
      type: 'linear',
      display: false,
      ticks: {
        min: 0,
        max: 1
      }
    }],
    xAxes: [{
      type: 'linear',
      display: false,
      ticks: {
        min: 0,
        max: 1
      }
    }]
  }
}

export default {
  name: 'voronoi-chart',
  extends: VoronoiChart,
  mixins: [reactiveChartMixin],
  props: {
    datasets: {
      type: [Object, Array],
      description: 'Chart datasets. This is overridden when `data` is provided'
    },
    data: {
      type: [Object, Array],
      description: 'Chart.js chart data (overrides all default data)'
    },
    extraOptions: {
      type: Object,
      description: 'Chart.js options'
    },
    title: {
      type: String,
      description: 'Chart title'
    }
  },
  methods: {
    assignChartData ({ data }) {
      return {
        datasets: this.datasets ? this.datasets : [{
          data: this.data || data
        }]
      }
    },
    assignChartOptions (initialConfig) {
      let extraOptions = this.extraOptions || {}
      return {
        ...initialConfig,
        ...extraOptions
      }
    }
  },
  mounted () {
    this.chartData = this.assignChartData({})
    this.options = this.assignChartOptions(chartOptionsConfiguration)
    this.renderChart(this.chartData, this.options)
  },
  activated () {
    // console.log('activated')
  },
  updated () {
    // console.log('updated')
  }
}
